import type { FaireProductEntity } from "../../entity_types/product";

export const p_6jmfmc473r: FaireProductEntity = {
  token: "p_6jmfmc473r",
  type: "product",
  name: "Oregano Oil  Drops",
  brandToken: "b_uccdexy6ud",
  brandName: "Body&Soul",
  imageUrl:
    "https://cdn.faire.com/fastly/50a0d388dbad9507dcd9b01761dadb16ab3f934de6555d69898a59bd7aea20a7.jpeg",
  galleryImageUrls: [],
  priceDollars: 5.99,
  description:
    "✨NEW✨ We have House-Made Oregano Oil Roll-Ons & Immunity Drops 👌 Roll these on cold sores & other fungal/skin issues to heal them, naturally 🌿 Oregano Oil Heals: Candida, High Cholesterol, Bacteria, & it's anti-inflammatory, + immune-boosting !",
  tags: [],
  msrpDollars: 14.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:05.211Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
